import request from '@/utils/request'

export function index(data) { //首页
  return request({
    url: 'api/index/index',
    method: 'get',
    data,
  })
}

export function indexbanner(data) { //首页轮播
  return request({
    url: 'api/index/banner',
    method: 'get',
    data,
  })
}

export function config_info(data) { //配置
  return request({
    url: 'api/index/config_info',
    method: 'post',
    data,
  })
}

export function cpzxList(data) { //产品中心列表
  return request({
    url: 'api/news_list/cpzxList',
    method: 'post',
    data,
  })
}

export function cpzxInfo(data) { //产品中心详情
  return request({
    url: 'api/news_info/cpzxInfo',
    method: 'post',
    data,
  })
}

export function jjfw_classs(data) { //解决方案类型
  return request({
    url: 'api/news_type/jjfw_classs',
    method: 'post',
    data,
  })
}

export function cgal_spList(data) { //视频案例-成功案例列表
  return request({
    url: 'api/news_list/cgal_spList',
    method: 'post',
    data,
  })
}

export function cgal_spInfo(data) { //视频案例-成功案例详情
  return request({
    url: 'api/news_info/cgal_spInfo',
    method: 'post',
    data,
  })
}

export function fwzx_type(data) { //服务资讯分类
  return request({
    url: 'api/news_type/fwzx_type',
    method: 'post',
    data,
  })
}

export function fwzxList(data) { //服务资讯列表
  return request({
    url: 'api/news_list/fwzxList',
    method: 'post',
    data,
  })
}

export function fwzxInfo(data) { //服务资讯详情
  return request({
    url: 'api/news_info/fwzxInfo',
    method: 'post',
    data,
  })
}

export function address_list(data) { //携手未来地区列表
  return request({
    url: 'api/index/address_list',
    method: 'get',
    data,
  })
}

export function jjfwList(data) { //解决方案列表
  return request({
    url: 'api/news_list/jjfwList',
    method: 'post',
    data,
  })
}

export function cpal_sptype(data) { //视频案例分类
  return request({
    url: 'api/news_type/cpal_sptype',
    method: 'post',
    data,
  })
}

export function cgal_twList(data) { //图文案例-成功案例列表
  return request({
    url: 'api/news_list/cgal_twList',
    method: 'post',
    data,
  })
}

export function cgal_sjList(data) { //设计作品-成功案例列表
  return request({
    url: 'api/news_list/cgal_sjList',
    method: 'post',
    data,
  })
}

export function jszs(data) { //技术基石
  return request({
    url: 'api/index/jszs',
    method: 'post',
    data,
  })
}

export function ryzz(data) { //荣誉资质
  return request({
    url: 'api/index/ryzz',
    method: 'post',
    data,
  })
}

export function yxtd(data) { //优秀团队
  return request({
    url: 'api/index/yxtd',
    method: 'post',
    data,
  })
}

export function feedback(data) { //优秀团队
  return request({
    url: 'api/index/feedback',
    method: 'post',
    data,
  })
}

export function rczpList(data) { //人才招聘列表
  return request({
    url: 'api/news_list/rczpList',
    method: 'post',
    data,
  })
}

export function images(data) { //图片配置列表
  return request({
    url: 'api/index/images',
    method: 'post',
    data,
  })
}